var _circle, _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1219_140)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 35.2564C33 32.3534 35.41 30 38.3828 30H56.2536C59.2264 30 61.6364 32.3534 61.6364 35.2564V59.6462C61.6364 62.5492 59.2264 64.9026 56.2536 64.9026H38.3828C35.41 64.9026 33 62.5492 33 59.6462V35.2564Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1219_140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5002 64.0338C69.0938 58.1691 68.6441 49.7454 63.1514 44.3815C57.1689 38.5395 47.4694 38.5395 41.4869 44.3815C35.5044 50.2236 35.5044 59.6954 41.4869 65.5374C46.9796 70.9013 55.6058 71.3403 61.6116 66.8546L66.2416 71.3759C66.662 71.7865 67.3436 71.7865 67.7641 71.3759L69.1302 70.0419C69.5506 69.6313 69.5506 68.9657 69.1302 68.5551L64.5002 64.0338Z",
    fill: "url(#paint1_linear_1219_140)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.5002 64.0338C69.0938 58.1691 68.6441 49.7454 63.1514 44.3815C57.1689 38.5395 47.4694 38.5395 41.4869 44.3815C35.5044 50.2236 35.5044 59.6954 41.4869 65.5374C46.9796 70.9013 55.6058 71.3403 61.6116 66.8546L66.2416 71.3759C66.662 71.7865 67.3436 71.7865 67.7641 71.3759L69.1302 70.0419C69.5506 69.6313 69.5506 68.9657 69.1302 68.5551L64.5002 64.0338Z",
    stroke: "url(#paint2_linear_1219_140)",
    strokeWidth: 0.5
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4039 56.5754L47.1943 53.2905L45 55.4022L50.4039 61L60 51.2793L57.8384 49L50.4039 56.5754Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1219_140",
    x: 34.85,
    y: 37.85,
    width: 36.7453,
    height: 35.9836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1219_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1219_140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_140",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1219_140",
    x1: 40.472,
    y1: 42.9232,
    x2: 75.1361,
    y2: 61.3033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1219_140",
    x1: 55.9265,
    y1: 45.2806,
    x2: 67.6132,
    y2: 73.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.ad82cbe124a6d878494a03f10cb81608.svg";
export { ForwardRef as ReactComponent };